import DATE_FORMATS from '../../shared/constants/dateFormats';
import { formatDate } from '../../shared/utility/dateFormatter';

// Contextual per-row summary, matching the reference portal's "Details" column: what happened
// to this item most recently (disposed / checked out / last transaction).
export const getRowDetails = (item) => {
  const disposition = Array.isArray(item.EvidenceDisposition)
    ? item.EvidenceDisposition[0]
    : item.EvidenceDisposition;

  if (disposition?.IsDisposed) {
    return `Disposed: ${disposition.FinalDisposition || '—'} on ${formatDate(
      disposition.DispositionDate,
      DATE_FORMATS.YYYY_MM_DD
    )}`;
  }

  const custody = Array.isArray(item.EvidenceCustody) ? item.EvidenceCustody : [];
  const lastCustody = [...custody].sort(
    (a, b) => new Date(b.TransactionDate) - new Date(a.TransactionDate)
  )[0];

  if (!lastCustody) return '—';

  if (item.Status === 'Out' && lastCustody.CustodyTo) {
    return `Checked out to: ${lastCustody.CustodyTo} on ${formatDate(
      lastCustody.TransactionDate,
      DATE_FORMATS.MM_DD_YYYY_HH_mm_A
    )}`;
  }

  return `${lastCustody.TransactionType || ''} — ${formatDate(
    lastCustody.TransactionDate,
    DATE_FORMATS.MM_DD_YYYY_HH_mm_A
  )}`;
};
